import { makeStyles } from '@material-ui/core'

import { Typography } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  supplierImage: {
    borderRadius: theme.shape.borderRadius / 2,
    height: 25,
    marginRight: theme.spacing(1),
    objectFit: 'cover',
    width: 25,
  },
  supplierName: {
    marginBottom: 0,
  },
  supplierNameContainer: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
}))

const OrganisationName = ({ logo, name, subtitle }) => {
  const classes = useStyles()

  return (
    <div className={classes.supplierNameContainer}>
      {logo && <img className={classes.supplierImage} src={logo} alt={name} />}
      <Typography variant="h3" color="orange" className={classes.supplierName}>
        {name}
        {subtitle && (
          <Typography color="textPrimary" variant="body2">
            {subtitle}
          </Typography>
        )}
      </Typography>
    </div>
  )
}

export default OrganisationName
